import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

// TODO: Replace w/blueprint
export default function Toggle({ checked, disabled, name, showText = true, small, theme, onChange }) {
  const wrapperClassName = classNames('form-check form-switch', theme);

  const inputClassName = classNames('form-check-input', {
    'form-switch-lg': !small,
  });

  return (
    <div className={wrapperClassName}>
      <input
        checked={checked}
        className={inputClassName}
        disabled={disabled}
        name={name}
        role="switch"
        type="checkbox"
        onChange={onChange}
      />
      {showText && !small && (
        <span className="fw-bold fs-small">{checked ? 'ON' : 'OFF'}</span>
      )}
    </div>
  );
}

Toggle.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  showText: PropTypes.bool,
  small: PropTypes.bool,
  theme: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
